export default "__VITE_ASSET__DQ7TF4vO__"